/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergeGoldenRecordsRequest
 */
export interface MergeGoldenRecordsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof MergeGoldenRecordsRequest
     */
    goldenRecordIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MergeGoldenRecordsRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the MergeGoldenRecordsRequest interface.
 */
export function instanceOfMergeGoldenRecordsRequest(value: object): value is MergeGoldenRecordsRequest {
    return true;
}

export function MergeGoldenRecordsRequestFromJSON(json: any): MergeGoldenRecordsRequest {
    return MergeGoldenRecordsRequestFromJSONTyped(json, false);
}

export function MergeGoldenRecordsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeGoldenRecordsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'goldenRecordIds': json['goldenRecordIds'] == null ? undefined : json['goldenRecordIds'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function MergeGoldenRecordsRequestToJSON(json: any): MergeGoldenRecordsRequest {
    return MergeGoldenRecordsRequestToJSONTyped(json, false);
}

export function MergeGoldenRecordsRequestToJSONTyped(value?: MergeGoldenRecordsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goldenRecordIds': value['goldenRecordIds'],
        'reason': value['reason'],
    };
}

